"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeAppWeb3Provider = void 0;
const events_1 = require("events");
const provider_utils_1 = require("../provider/provider-utils");
/**
 * EIP-1193: Ethereum Provider JavaScript API
 * https://eips.ethereum.org/EIPS/eip-1193
 *
 * Proxies provider requests over the message
 * bus into studio client (EthereumProvider)
 */
class BridgeAppWeb3Provider extends events_1.EventEmitter {
    constructor(chainInfo, sdk) {
        super();
        this.connected = true;
        this.isManifoldAppBridge = true;
        this.sdk = sdk;
        this.sdk.on('chainChanged', ({ id }) => this.emit('chainChanged', { chainId: (0, provider_utils_1.toHex)(id) }));
        this.sdk.on('addressChanged', ({ address }) => this.emit('accountsChanged', { accounts: [address] }));
        this.emit('connect', { chainId: (0, provider_utils_1.toHex)(chainInfo.id) });
    }
    request(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdk.ethereum(request);
        });
    }
    // ethers v4 support (credit: gnosis safe apps)
    send(request, callback) {
        if (!request)
            callback('Undefined request');
        this.request(request)
            .then((result) => callback(null, { jsonrpc: '2.0', id: request.id, result }))
            .catch((error) => callback(error, null));
    }
}
exports.BridgeAppWeb3Provider = BridgeAppWeb3Provider;
//# sourceMappingURL=provider.js.map